import type { APIBuildingImages, APIDeletedImage } from "../model/types";

export const convertPrefillImagesToFormData = (images: APIBuildingImages | undefined): APIDeletedImage[] => {
  if (!images) return [];
  return images.images.map((image) => ({
    file: new File([], image.imageUrl, { type: "image/jpeg" }),
    id: String(image.id),
    shouldBeDeleted: false,
    source: "api",
    url: image.imageUrl,
  }));
};
